import { useBillingStatusContent } from "./useBillingStatusContent";
import { BillingNudgeAlert } from "./BillingNudgeAlert";
import { UpdateAvailableNudge } from "./UpdateAvailableNudge";

export const NavDrawerNudge = () => {
  const billingContent = useBillingStatusContent();
  if (billingContent) return <BillingNudgeAlert />;
  return <UpdateAvailableNudge />;
};
